<div>
  <mat-dialog-content *ngIf="!isDivestEnabled">
    <div class="broker-contact-us broker-post-contact-us">
      <div class="abc">
        <div class="close">
          <button
            data-test-id="closeLink"
            cg-mat-btn-type="link"
            aria-label="close"
            (click)="close(false)"
            class="dialog-close-wrapper"
          >
            {{ 'profile.closeBtn' | translate }}
            <mat-icon aria-hidden="true" class="dialog-close-icon"></mat-icon>
          </button>
        </div>
        <div
          class="conCig"
          *ngIf="isPreloginNewUiEnabled && !isImpersonatorFlag"
        >
          <div id="changeMobPhnHdr" data-test-id="contact-us-header">
            {{ 'preLoginContactUs.pageHeader' | translate }}
          </div>
        </div>
        <div
          class="conCig"
          *ngIf="!isPreloginNewUiEnabled && !isImpersonatorFlag"
        >
          <h5 id="changeMobPhnHdr" data-test-id="contact-us-header">
            {{ 'preLoginContactUs.pageHeader' | translate }}
          </h5>
        </div>
        <div class="impHeader" *ngIf="isImpersonatorFlag">
          <div id="changeMobPhnHdr" data-test-id="contact-us-header">
            {{ 'impersonatorContactUs.pageHeader' | translate }}
          </div>
        </div>
      </div>

      <div
        *ngIf="isPublicContactUs && !isPreloginNewUiEnabled"
        class="contactContainer"
        fxLayout.lt-md="column"
      >
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="50" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-2">
              {{ 'profileCotactUs.r1.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container ml" fxFlex="50">
            <span fxLayout="row" class="phone" data-test-id="phone-2">{{
              'profileCotactUs.r1.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-2">{{
              'profileCotactUs.r1.time' | translate
            }}</span>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="50" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-2">
              {{ 'profileCotactUs.r2.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container" fxFlex="50">
            <span fxLayout="row" class="phone" data-test-id="phone-2">{{
              'profileCotactUs.r2.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-2">{{
              'profileCotactUs.r2.time' | translate
            }}</span>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="50" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-3">
              {{ 'profileCotactUs.r3.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container" fxFlex="50">
            <span fxLayout="row" class="phone" data-test-id="phone-3">{{
              'profileCotactUs.r3.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-3">{{
              'profileCotactUs.r3.time' | translate
            }}</span>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="50" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-4">
              {{ 'profileCotactUs.r4.title' | translate }}
            </div>
          </div>
          <div
            fxLayout="column"
            class="phone-container lastDivPublic"
            fxFlex="50"
          >
            <a
              (click)="goToPreLoginContactUs('commercial')"
              fxLayout="row"
              class="phone-wide"
              data-test-id="phone-4"
            >
              {{ 'profileCotactUs.r4.linkText' | translate }}
            </a>
          </div>
        </div>
      </div>

      <div
        *ngIf="isPublicContactUs && isPreloginNewUiEnabled"
        class="contactContainer"
        fxLayout.lt-md="column"
      >
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="70">
            <div
              [ngClass]="
                (isDivestEnabled ? 1 : 0) === 1
                  ? 'headerTxt1 brTitle mat-column-title'
                  : 'headerTxt brTitle mat-column-title'
              "
              data-test-id="title-2"
            >
              {{ 'preLoginContactUs.questionsHeading' | translate }}
            </div>

            <div
              [ngClass]="
                (isDivestEnabled ? 1 : 0) === 1
                  ? 'ulContent1 ulContentLatest'
                  : 'ulContent'
              "
              fxLayout.lt-md="column"
            >
              <ul *ngFor="let item of preLoginQuestions">
                <li>{{ item | translate }}</li>
              </ul>
            </div>
          </div>
          <div fxLayout="column" class="phone-container ml" fxFlex="30">
            <span
              fxLayout="row"
              [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? 'phone1' : 'phone'"
              data-test-id="phone-2"
              >{{ 'preLoginContactUs.contactNumber' | translate }}</span
            >
            <br />
            <span
              fxLayout="row"
              [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? 'time1' : 'time'"
              data-test-id="time-2"
              >{{ 'preLoginContactUs.contactHours' | translate }}</span
            >
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div
          [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? '' : 'paddingTop'"
          xLayout="row"
          fxLayout.lt-md="column"
        >
          <div fxFlex="65" class="headerTxt">
            <div
              class="headerTxt brTitle mat-column-title lastDivPublic"
              data-test-id="title-4"
            >
              {{ 'preLoginContactUs.accessCodeHeading' | translate }}
            </div>
          </div>
          <div
            fxLayout="column"
            [ngClass]="
              (isDivestEnabled ? 1 : 0) === 1
                ? 'phone-container lastDivPublicLatest'
                : 'phone-container lastDivPublic'
            "
            fxFlex="35"
          >
            <a
              (click)="goToAccessCodePage()"
              fxLayout="row"
              class="phone-wide"
              data-test-id="phone-4"
            >
              {{ 'preLoginContactUs.accessCodeText' | translate }}
            </a>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>

        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          *ngIf="isOnboardingFlagEnabled"
        >
          <div fxFlex="60" class="headerTxt">
            <!-- <div class="caret-icon">
              <cigna-icon
                *ngIf="slideOpen"
                type="caret-down"
                class="color-caret-icon"
              ></cigna-icon
              ><cigna-icon
                *ngIf="!slideOpen"
                type="caret-right"
                class="color-caret-icon"
              ></cigna-icon>
            </div> -->
            <div class="caret-icon-text">
              <a
                (click)="toggleGetAppointed()"
                fxLayout="row"
                class="headerTxt link"
                data-test-id="phone-4"
              >
                {{ 'preLoginContactUs.needApppointmentHeading' | translate }}
              </a>
            </div>
          </div>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          *ngIf="!isOnboardingFlagEnabled && !isDivestEnabled"
        >
          <div fxFlex="60" class="headerTxt">
            <div class="caret-icon">
              <cigna-icon
                *ngIf="slideOpen"
                type="caret-down"
                class="color-caret-icon"
              ></cigna-icon
              ><cigna-icon
                *ngIf="!slideOpen"
                type="caret-right"
                class="color-caret-icon"
              ></cigna-icon>
            </div>
            <div class="caret-icon-text">
              <a
                (click)="toggleGetAppointedOld()"
                fxLayout="row"
                class="headerTxt link"
                data-test-id="phone-4"
              >
                {{ 'preLoginContactUs.needApppointmentHeading' | translate }}
              </a>
            </div>
          </div>
        </div>

        <div *ngIf="slideOpen" class="slide-open-content">
          <div
            *ngFor="
              let k of getAppointedData | keyvalue;
              let i = index;
              let l = count
            "
          >
            <div
              [fxHide]="
                isDivestEnabled &&
                (k.value['title'] === 'Medicare' ||
                  k.value['title'] === 'Cigna Supplemental Benefits (CSB)')
              "
              class="paddingTop"
            >
              <div fxLayout="row" class="rows" fxLayout.lt-md="column">
                <div fxFlex="75%" fxLayoutGap="" class="textFull">
                  <div fxLayout="row" fxLayout.lt-md="column" class="headerTxt">
                    {{ k.value['title'] }}
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" class="ulContent">
                    {{ k.value['text'] }}
                  </div>
                </div>
                <div
                  fxLayout="column"
                  class="phone-container1 ml"
                  fxFlex="35%"
                  fxLayoutGap=""
                >
                  <span
                    fxLayout="row"
                    class="phone"
                    *ngIf="k.value['mobile']"
                    data-test-id="phone-1"
                    >{{ k.value['mobile'] }}</span
                  >
                  <span
                    fxLayout="row"
                    class="phone"
                    *ngIf="k.value['mobile1']"
                    data-test-id="phone-1"
                    >{{ k.value['mobile1'] }}</span
                  >
                  <span
                    fxLayout="row"
                    class="time"
                    *ngIf="k.value['hours']"
                    data-test-id="time-2"
                    >{{ k.value['hours'] }}</span
                  >
                  <div class="email">
                    <a
                      class="link"
                      data-test-id="email-1"
                      (click)="sendMail(k.value['email'])"
                      >{{ k.value['email'] }}</a
                    >
                  </div>
                </div>
              </div>
              <mat-divider
                *ngIf="i + 1 < l"
                class="divider-spacer divider-spacer-m"
              ></mat-divider>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="!isPublicContactUs && !isImpersonatorFlag"
        class="contactContainer"
      >
        <div
          fxLayout="row"
          fxLayout.lt-md="column"
          fxHide.lt-md
          class="headerTxt header-cels"
        >
          <div fxFlex="34" class="bg-head"></div>
          <div
            fxLayout="column"
            fxFlex="36"
            class="bg-head"
            data-test-id="phone-lbl"
          >
            PHONE
          </div>
          <div class="bg-head" fxFlex="30" data-test-id="email-lbl">EMAIL</div>
        </div>
        <mat-divider class="divider-spacer aftHead"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="34" class="headerTxt" data-test-id="title-1">
            <div class="brTitle mat-column-title">
              {{ 'profileCotactUs.r1.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container" fxFlex="36">
            <span fxLayout="row" class="phone" data-test-id="phone-1">{{
              'profileCotactUs.r1.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-1">{{
              'profileCotactUs.r1.time' | translate
            }}</span>
          </div>
          <div fxFlex="30" class="e-mail-container">
            <div class="brEmail email">
              <a
                data-test-id="email-1"
                href="{{ sendEmail('profileCotactUs.r1.email' | translate) }}"
                >{{ 'profileCotactUs.r1.email' | translate }}</a
              >
            </div>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="34" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-2">
              {{ 'profileCotactUs.r2.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container" fxFlex="36">
            <span fxLayout="row" class="phone" data-test-id="phone-2">{{
              'profileCotactUs.r2.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-2">{{
              'profileCotactUs.r2.time' | translate
            }}</span>
          </div>
          <div fxFlex="30" class="e-mail-container">
            <div class="brEmail email">
              <a
                data-test-id="email-2"
                href="{{ sendEmail('profileCotactUs.r2.email' | translate) }}"
              >
                {{ 'profileCotactUs.r2.newEmail' | translate }}
              </a>
            </div>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="34" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-3">
              {{ 'profileCotactUs.r3.title' | translate }}
            </div>
          </div>
          <div fxLayout="column" class="phone-container" fxFlex="36">
            <span fxLayout="row" class="phone" data-test-id="phone-3">{{
              'profileCotactUs.r3.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-3">{{
              'profileCotactUs.r3.time' | translate
            }}</span>
          </div>
          <div fxFlex="30" class="e-mail-container">
            <div class="brEmail email">
              <a
                data-test-id="email-3"
                href="{{ sendEmail('profileCotactUs.r3.email' | translate) }}"
                >{{ 'profileCotactUs.r3.email' | translate }}</a
              >
            </div>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
        <div fxLayout="row" fxLayout.lt-md="column">
          <div fxFlex="34" class="headerTxt">
            <div class="brTitle mat-column-title" data-test-id="title-4">
              {{ 'profileCotactUs.r4.title' | translate }}
            </div>
          </div>
          <div
            fxLayout="column"
            class="phone-container"
            fxHide.lt-md
            fxFlex="36"
          >
            <span fxLayout="row" class="phone" data-test-id="phone-4">{{
              'profileCotactUs.r4.phone' | translate
            }}</span>
            <span fxLayout="row" class="time" data-test-id="time-4">{{
              'profileCotactUs.r4.time' | translate
            }}</span>
          </div>
          <div class="lastDiv e-mail-container" fxFlex="30">
            <div class="brEmail email">
              <div>
                <a
                  class="contact-us-link"
                  (click)="redirectToForm('commercial')"
                >
                  <span>
                    {{ 'profileCotactUs.r4.linkText' | translate }}
                  </span>

                  <cigna-icon
                    class="arrow-right"
                    [type]="'chevron-thin-right'"
                  ></cigna-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
        <mat-divider class="divider-spacer"></mat-divider>
      </div>
      <div *ngIf="!isPublicContactUs && isImpersonatorFlag" class="lastDivImp">
        <p class="impLinkLabel">
          {{ 'impersonatorContactUs.helpCommercial' | translate }}
        </p>
        <p fxLayout="row">
          <a
            href="{{
              sendEmail('impersonatorContactUs.emailAddress' | translate)
            }}"
            class="impLink"
          >
            {{ 'impersonatorContactUs.emailLink' | translate }}
          </a>
        </p>

        <p class="impLinkLabel">
          {{ 'impersonatorContactUs.helpOthers' | translate }}
        </p>
        <p fxLayout="row">
          <a (click)="goToServiceNow()" class="impLink">
            {{ 'impersonatorContactUs.submitTicket' | translate }}
          </a>
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Start: Divestiture Flow -->
  <div class="broker-contact-us broker-post-contact-us" *ngIf="isDivestEnabled">
    <div
      [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? '' : 'paddingTop'"
      xLayout="row"
      fxLayout.lt-md="column"
      class="fullWidth"
    >
      <div fxFlex="96" class="headerTxt">
        <div
          class="conCig1"
          data-test-id="title-4"
          *ngIf="isPreloginNewUiEnabled && !isImpersonatorFlag"
        >
          {{ 'preLoginContactUs.pageHeader' | translate }}
        </div>

        <div
          id="changeMobPhnHdr"
          data-test-id="contact-us-header"
          class="impHeader"
          *ngIf="isImpersonatorFlag"
        >
          {{ 'impersonatorContactUs.pageHeader' | translate }}
        </div>
      </div>
      <div fxLayout="column" class="closeLink dialog-close-wrapper1" fxFlex="6">
        <a
          (click)="close(false)"
          fxLayout="row"
          class="close dialog-close-wrapper"
          data-test-id="closeLink"
          cg-mat-btn-type="link"
        >
          <mat-icon aria-hidden="true" class="dialog-close-icon"></mat-icon>
        </a>
      </div>
    </div>

    <div
      *ngIf="isPublicContactUs && isPreloginNewUiEnabled"
      class="contactContainer1"
      fxLayout.lt-md="column"
    >
      <div fxLayout="row" fxLayout.lt-md="column" class="fullWidth">
        <div fxFlex="80">
          <div
            [ngClass]="
              (isDivestEnabled ? 1 : 0) === 1
                ? 'headerTxt1 brTitle mat-column-title'
                : 'headerTxt brTitle mat-column-title'
            "
            data-test-id="title-2"
          >
            {{ 'preLoginContactUs.questionsHeading' | translate }}
          </div>

          <div
            [ngClass]="
              (isDivestEnabled ? 1 : 0) === 1
                ? 'ulContent1 ulContentLatest'
                : 'ulContent'
            "
            fxLayout.lt-md="column"
          >
            <ul *ngFor="let item of preLoginQuestions">
              <li>{{ item | translate }}</li>
            </ul>
          </div>
        </div>
        <div fxLayout="column" class="phone-container ml" fxFlex="20">
          <span
            fxLayout="row"
            [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? 'phone1' : 'phone'"
            data-test-id="phone-2"
            >{{ 'preLoginContactUs.contactNumber' | translate }}</span
          >
          <br />
          <span fxLayout="row" class="time1" data-test-id="time-2">{{
            'preLoginContactUs.contactHours' | translate
          }}</span>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>
      <div
        [ngClass]="(isDivestEnabled ? 1 : 0) === 1 ? '' : 'paddingTop'"
        xLayout="row"
        fxLayout.lt-md="column"
        class="fullWidth"
      >
        <div fxFlex="80" class="headerTxt">
          <div
            class="headerTxt1 brTitle mat-column-title lastDivPublic"
            data-test-id="title-4"
          >
            {{ 'preLoginContactUs.accessCodeHeading' | translate }}
          </div>
        </div>
        <div
          fxLayout="column"
          [ngClass]="
            (isDivestEnabled ? 1 : 0) === 1
              ? 'phone-container lastDivPublicLatest'
              : 'phone-container lastDivPublic'
          "
          fxFlex="20"
        >
          <a
            (click)="goToAccessCodePage()"
            fxLayout="row"
            class="phone-wide1"
            data-test-id="phone-4"
          >
            {{ 'preLoginContactUs.accessCodeText' | translate }}
          </a>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>

      <div
        fxLayout="row"
        fxLayout.lt-md="column"
        *ngIf="isOnboardingFlagEnabled"
      >
        <div fxFlex="60" class="headerTxt">
          <div class="caret-icon-text">
            <a
              (click)="toggleGetAppointed()"
              fxLayout="row"
              class="headerTxt link"
              data-test-id="phone-4"
            >
              {{ 'preLoginContactUs.needApppointmentHeading' | translate }}
            </a>
          </div>
        </div>
      </div>

      <!-- Divestiture Enabled Flow -->
      <div
        fxLayout="row"
        fxLayout.lt-md="column"
        *ngIf="!isOnboardingFlagEnabled && isDivestEnabled"
      >
        <div fxFlex="60" class="lobExpand">
          <div class="caret-icon-text headerSpace">
            <span fxLayout="row" class="headerTxt1" data-test-id="phone-4">
              {{ 'preLoginContactUs.needApppointmentHeading' | translate }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="!isOnboardingFlagEnabled && isDivestEnabled">
        <div
          *ngFor="
            let k of getAppointedData | keyvalue;
            let i = index;
            let l = count
          "
          class="lobExpand"
        >
          <div
            [fxHide]="
              k.value['title'] === 'Medicare' ||
              k.value['title'] === 'Cigna Supplemental Benefits (CSB)'
            "
          >
            <div class="caret-icon-text" (click)="toggleLobs(k.value['title'])">
              <a
                class="subHeaderTxt1 headerLink leftPadding"
                data-test-id="phone-4"
              >
                {{ k.value['title'] }}
              </a>
            </div>
            <div
              *ngIf="
                (k.value['title'] === 'U.S. Employer Plans' && isUsempLobOn) ||
                (k.value['title'] === 'Cigna Small Group Plans' &&
                  isSgpLobOn) ||
                (k.value['title'] === 'Cigna Individual & Family Plans' &&
                  isIfpLobOn)
              "
              class="up-arrow-icon"
              (click)="toggleLobs(k.value['title'])"
            ></div>

            <div
              *ngIf="
                (k.value['title'] === 'U.S. Employer Plans' && !isUsempLobOn) ||
                (k.value['title'] === 'Cigna Small Group Plans' &&
                  !isSgpLobOn) ||
                (k.value['title'] === 'Cigna Individual & Family Plans' &&
                  !isIfpLobOn)
              "
              class="down-arrow-icon"
              (click)="toggleLobs(k.value['title'])"
            ></div>
          </div>

          <div
            class="slide-open-content1"
            [fxHide]="
              k.value['title'] === 'Medicare' ||
              k.value['title'] === 'Cigna Supplemental Benefits (CSB)'
            "
          >
            <div
              *ngIf="k.value['title'] === 'U.S. Employer Plans' && isUsempLobOn"
            >
              {{ k.value['text1'] }}
            </div>

            <div
              class="email1"
              *ngIf="k.value['title'] === 'U.S. Employer Plans' && isUsempLobOn"
            >
              <a
                class="link"
                data-test-id="email-1"
                (click)="sendMail(k.value['email'])"
                >{{ k.value['email'] }}</a
              >
            </div>

            <div
              *ngIf="
                k.value['title'] === 'Cigna Small Group Plans' && isSgpLobOn
              "
            >
              {{ k.value['text'] }}
            </div>

            <div
              class="email1"
              *ngIf="
                k.value['title'] === 'Cigna Small Group Plans' && isSgpLobOn
              "
            >
              <a
                class="link"
                data-test-id="email-1"
                (click)="sendMail(k.value['email'])"
                >{{ k.value['email'] }}</a
              >
            </div>

            <div
              *ngIf="
                k.value['title'] === 'Cigna Individual & Family Plans' &&
                isIfpLobOn
              "
            >
              {{ k.value['text'] }}
            </div>

            <div
              xLayout="row"
              fxLayout.lt-md="column"
              *ngIf="
                k.value['title'] === 'Cigna Individual & Family Plans' &&
                isIfpLobOn
              "
              class="fullWidth"
            >
              <div fxFlex="85" class="phone-container">
                <div class="ifp-phone-container" data-test-id="title-4">
                  <span
                    class="ifp-phone-container"
                    fxLayout="row"
                    *ngIf="k.value['mobile']"
                    data-test-id="phone-1"
                    >{{ k.value['mobile'] }} {{ k.value['mobile1'] }}</span
                  >
                </div>
              </div>
              <div fxLayout="column" class="phone-container" fxFlex="15">
                <span
                  fxLayout="row"
                  class="time1"
                  *ngIf="k.value['hours']"
                  data-test-id="time-2"
                  >{{ k.value['hours'] }}</span
                >
              </div>
            </div>

            <div
              class="email1 emailLastDiv"
              *ngIf="
                k.value['title'] === 'Cigna Individual & Family Plans' &&
                isIfpLobOn
              "
            >
              <a
                class="link"
                data-test-id="email-1"
                (click)="sendMail(k.value['email'])"
                >{{ k.value['email'] }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!isPublicContactUs && !isImpersonatorFlag"
      class="contactContainer"
    >
      <div
        fxLayout="row"
        fxLayout.lt-md="column"
        fxHide.lt-md
        class="headerTxt header-cels"
      >
        <div fxFlex="34" class="bg-head"></div>
        <div
          fxLayout="column"
          fxFlex="36"
          class="bg-head"
          data-test-id="phone-lbl"
        >
          PHONE
        </div>
        <div class="bg-head" fxFlex="30" data-test-id="email-lbl">EMAIL</div>
      </div>
      <mat-divider class="divider-spacer aftHead"></mat-divider>
      <div fxLayout="row" fxLayout.lt-md="column">
        <div fxFlex="34" class="headerTxt" data-test-id="title-1">
          <div class="brTitle mat-column-title">
            {{ 'profileCotactUs.r1.title' | translate }}
          </div>
        </div>
        <div fxLayout="column" class="phone-container" fxFlex="36">
          <span fxLayout="row" class="phone" data-test-id="phone-1">{{
            'profileCotactUs.r1.phone' | translate
          }}</span>
          <span fxLayout="row" class="time" data-test-id="time-1">{{
            'profileCotactUs.r1.time' | translate
          }}</span>
        </div>
        <div fxFlex="30" class="e-mail-container">
          <div class="brEmail email">
            <a
              data-test-id="email-1"
              href="{{ sendEmail('profileCotactUs.r1.email' | translate) }}"
              >{{ 'profileCotactUs.r1.email' | translate }}</a
            >
          </div>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>
      <div fxLayout="row" fxLayout.lt-md="column">
        <div fxFlex="34" class="headerTxt">
          <div class="brTitle mat-column-title" data-test-id="title-2">
            {{ 'profileCotactUs.r2.title' | translate }}
          </div>
        </div>
        <div fxLayout="column" class="phone-container" fxFlex="36">
          <span fxLayout="row" class="phone" data-test-id="phone-2">{{
            'profileCotactUs.r2.phone' | translate
          }}</span>
          <span fxLayout="row" class="time" data-test-id="time-2">{{
            'profileCotactUs.r2.time' | translate
          }}</span>
        </div>
        <div fxFlex="30" class="e-mail-container">
          <div class="brEmail email">
            <a
              data-test-id="email-2"
              href="{{ sendEmail('profileCotactUs.r2.email' | translate) }}"
            >
              {{ 'profileCotactUs.r2.newEmail' | translate }}
            </a>
          </div>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>
      <div fxLayout="row" fxLayout.lt-md="column">
        <div fxFlex="34" class="headerTxt">
          <div class="brTitle mat-column-title" data-test-id="title-3">
            {{ 'profileCotactUs.r3.title' | translate }}
          </div>
        </div>
        <div fxLayout="column" class="phone-container" fxFlex="36">
          <span fxLayout="row" class="phone" data-test-id="phone-3">{{
            'profileCotactUs.r3.phone' | translate
          }}</span>
          <span fxLayout="row" class="time" data-test-id="time-3">{{
            'profileCotactUs.r3.time' | translate
          }}</span>
        </div>
        <div fxFlex="30" class="e-mail-container">
          <div class="brEmail email">
            <a
              data-test-id="email-3"
              href="{{ sendEmail('profileCotactUs.r3.email' | translate) }}"
              >{{ 'profileCotactUs.r3.email' | translate }}</a
            >
          </div>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>
      <div fxLayout="row" fxLayout.lt-md="column">
        <div fxFlex="34" class="headerTxt">
          <div class="brTitle mat-column-title" data-test-id="title-4">
            {{ 'profileCotactUs.r4.title' | translate }}
          </div>
        </div>
        <div fxLayout="column" class="phone-container" fxHide.lt-md fxFlex="36">
          <span fxLayout="row" class="phone" data-test-id="phone-4">{{
            'profileCotactUs.r4.phone' | translate
          }}</span>
          <span fxLayout="row" class="time" data-test-id="time-4">{{
            'profileCotactUs.r4.time' | translate
          }}</span>
        </div>
        <div class="lastDiv e-mail-container" fxFlex="30">
          <div class="brEmail email">
            <div>
              <a class="contact-us-link" (click)="redirectToForm('commercial')">
                <span>
                  {{ 'profileCotactUs.r4.linkText' | translate }}
                </span>

                <cigna-icon
                  class="arrow-right"
                  [type]="'chevron-thin-right'"
                ></cigna-icon>
              </a>
            </div>
          </div>
        </div>
      </div>
      <mat-divider class="divider-spacer"></mat-divider>
    </div>
    <div *ngIf="!isPublicContactUs && isImpersonatorFlag" class="lastDivImp">
      <p class="impLinkLabel">
        {{ 'impersonatorContactUs.helpCommercial' | translate }}
      </p>
      <p fxLayout="row">
        <a
          href="{{
            sendEmail('impersonatorContactUs.emailAddress' | translate)
          }}"
          class="impLink"
        >
          {{ 'impersonatorContactUs.emailLink' | translate }}
        </a>
      </p>

      <p class="impLinkLabel">
        {{ 'impersonatorContactUs.helpOthers' | translate }}
      </p>
      <p fxLayout="row">
        <a (click)="goToServiceNow()" class="impLink">
          {{ 'impersonatorContactUs.submitTicket' | translate }}
        </a>
      </p>
    </div>
  </div>
  <!-- End: Divestiture Flow -->
</div>
